import ChampionshipRegistration from "./ChampionshipRegistration";

export default ChampionshipRegistration;
